// import _ from "lodash";
import Indicador from "..";
import ARSUBEditFields from "./components/ARSUBEditFields";
import { ARSUBParamFields } from "./components/ARSUBParamFields";
import ReportSummary from "./reports/summary";
import apontamentoReport from "./reports/index";


export default class ARSUB extends Indicador {
    static get fullName() {
        return "Profundidade de Aração/Subsolagem";
    }

    static get abbrev() {
        return "Ar./Sub.";
    }
    static get field() {
        return "arsub";
    }


    static get legacyApontamentoMap() {
        return {
            dataHoraNGV: {
                newField: "date",
                convert: this.parseLegacyDate,
            },

            tipo: "tipo",
            talhao: "talhao",
            trator: "trator",
            implemento: "implemento",
            frente: "frente",


            tipoIndicador: "tipoIndicador",
            turno: "turno",



            coletas: {
                type: Array,
                newField: "coletas",
                children: {
                    profundidadeColeta: "profundidadeColeta",
                    conforme: "conforme",
                    observacao: "observacao",
                    foto: {
                        newField: "image.uid",
                        convert: this.convertLegacyImageUid,
                    },
                    confirmaRelatorio: "confirmaRelatorio",
                    "foto.georeferencia": "georeferencia",
                    georeferencia: "georeferencia",
                },
            },

            conformidadeAmostra: "conformidade",
            observacaoAmostra: "observacao",

            itensColeta: "images",
        };
    }

    static get legacyParamMap() {
        return {


            psPintervaloAderenciaMinimoManual: "manual.intervaloMin",
            psPintervaloAderenciaMaximoManual: "manual.intervaloMax",
            psPvalorMetaManual: "manual.meta",

            psPintervaloAderenciaMinimoMecanizado: "mecanizado.intervaloMin",
            psPintervaloAderenciaMaximoMecanizado: "mecanizado.intervaloMax",
            psPvalorMetaMecanizado: "mecanizado.meta",

            pontosAmostradosAracaoSubsolagem: {
                type: Array,
                newField: "items",
                paramMap: {
                    classificacaoPSpontosAmostrados: "classificacao",
                    intervalo1PSpontosAmostrados: "intervaloMin",
                    intervalo2PSpontosAmostrados: "intervaloMax",
                    sinalIntervaloMin: "sinalIntervaloMin",
                    sinalIntervaloMax: "sinalIntervaloMax",
                },
            },
        };
    }

    static paramFields(tipoIndicadorField = '') {
        return <ARSUBParamFields tipoIndicadorField={tipoIndicadorField} />
    }

    static getEditFields(visita, isNew, TipoClass) {
        return <ARSUBEditFields visita={visita} TipoClass={TipoClass} />
    }

    async renderReport(visita) {
        return apontamentoReport(this, visita);
    }

    async renderReportSummary(visita, tipoName) {
        return ReportSummary(this, visita, tipoName);
    }

    static calcConformidade(apontamento, params) {
        console.log("params ", params);
        console.log("apontamento ", apontamento);
        // let conformidade = 0
        const f = parseFloat;

        if (!apontamento.coletas || !params || apontamento.coletas.length === 0) {
            return 0;
        }

        let conformeCount = 0;
        const total = apontamento.coletas.length;

        for (const coleta of apontamento.coletas) {
            if (
                f(coleta.profundidadeColeta) >= f(params.intervaloMin) &&
                f(coleta.profundidadeColeta) <= f(params.intervaloMax)
            ) {
                coleta.conforme = "Sim";
                coleta.acima = 0
                coleta.abaixo = 0
                conformeCount++;
            } else {
                coleta.conforme = "Não";
                if (f(coleta.profundidadeColeta) > f(params.intervaloMax)) {
                    coleta.acima = 1
                    coleta.abaixo = 0
                } else {
                    coleta.acima = 0
                    coleta.abaixo = 1
                }
            }
        }
        return ((100 * conformeCount) / total).toFixed(2);
    }

    static getConformidadeStatus(conformidade, meta) {
        return this.calcConformidadeStatus(conformidade, meta, 89.47, 100, 103.15);
    }

    static calcPontosAmostrados(apontamento, paramItems) {
        const result = [];

        for (const item of paramItems) {
            let count = 0;

            for (const coleta of apontamento.coletas) {
                if (this.calcPontoAmostradoColeta(item, coleta.profundidadeColeta)) {
                    count++;
                }
            }

            result.push({
                ...item,
                count: count,
            });
        }

        return result;
    }

    static getResultStr(apontamento) {
        return ""
    }

    static getTableRelApontamentos(paramsCliente, IndicadorClass) {
        return [
            { title: "Data", width: 'auto', getValue: (a) => a.dataRef.split("-").reverse().join('/') },
            { title: "Laudo", field: "laudoRef.sequencialIndex", width: 28 },
            { title: "Cod.", field: "laudoRef.fazenda.codFazenda", width: 'auto' },
            { title: "Fazenda", field: "laudoRef.fazenda.nomeFazenda" },

            { title: "Talhão", field: "talhao.nome" },

            { title: "Frota", field: "trator.numeroFrotaTrator", width: 'auto' },
            { title: "Frente", field: "frente", width: 'auto' },
            { title: "Implemento", field: "implemento.nomeImplemento", width: 'auto' },

            {
                title: "Conf.(%)", field: "conformidade", width: 38, getColor: a => {
                    return IndicadorClass.getColorStatus(IndicadorClass.getConformidadeStatus(a.conformidade, paramsCliente?.meta))
                }
            },
        ]
    }
}
